import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { DocumentMaster } from "../model/DocumentMaster.model";
import { EnrollCourseMaster } from "../model/EnrollCourseMaster.model";
import { ExamMaster } from "../model/ExamMaster.model";
import { ExamMCQMaster } from "../model/ExamMCQMaster.model";
import { LookupData } from "../model/LookupData.model";
import { MCQOptionMaster } from "../model/MCQOptionMaster.model";
import { PredefinedMaster } from "../model/PredefinedMaster.model";
import { AuthService } from "../service/auth.service";
import { MainserviceService } from "../service/mainservice.service";
import { HttpErrorResponse } from "@angular/common/http";

declare var require: any;
const FileSaver = require("file-saver");

@Component({
  selector: "app-exam",
  templateUrl: "./exam.component.html",
  styleUrls: ["./exam.component.scss"],
})
export class ExamComponent implements OnInit {
  examfinish: boolean = false;

  timerSeconds: number = 0;
  timerMinute: number = 0;
  actualSeconds: number = 0;
  interval;
  timerRunning = false;

  examMaster: ExamMaster = new ExamMaster();
  examMCQMaster: ExamMCQMaster = new ExamMCQMaster();
  mcqOptionMasterList: MCQOptionMaster[] = [];

  nextButtonText: string = "Next";
  prevButtonText: string = "Previous";
  cancelButtonText: string = "Cancel";
  flagUnflagText: string = "Flag";
  enrollCourseMasterTemp = new EnrollCourseMaster();

  displayEndExam: boolean = true;
  questionNoError: boolean = false;
  questionError: boolean = false;

  showPreviousButton: boolean = true;
  showCancelButton: boolean = false;
  showNextButton: boolean = true;

  lookupCode: string = "";

  errorMessage: string = "";
  timerText: string = "";

  completePercentage: number = 0;

  showEndExamDialog: boolean = false;

  constructor(
    private router: Router,
    private mainService: MainserviceService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.startExam();
  }

  saveExamMasterAndGetExamMCQ(lookupCode: string) {
    let examMasterTemp = new ExamMaster();

    this.enrollCourseMasterTemp = new EnrollCourseMaster();
    this.enrollCourseMasterTemp.enrollCourseMasterId =
      this.authService.getEnrollCourseMasterSession().enrollCourseMasterId;
    examMasterTemp.enrollCourseMaster = this.enrollCourseMasterTemp;

    let typeTemp = new LookupData();
    typeTemp.lookupCode = lookupCode;
    examMasterTemp.type = typeTemp;

    this.mainService
      .saveExamMasterAndGetExamMCQ(examMasterTemp)
      .subscribe((data) => {
        this.examMCQMaster = data;

        this.setSelectedMCQMaster(lookupCode);

        if (
          this.examMCQMaster.durationLeftInSeconds != null &&
          this.examMCQMaster.isCompleted != true
        ) {
          this.startTimer();
        }
      });
  }

  selectOption(selectedMcqOptionMaster: MCQOptionMaster) {
    if (selectedMcqOptionMaster.isCompleted == false) {
      this.examMCQMaster.mcqOptionMaster = null;
      this.examMCQMaster.mcqMaster.mcqOptionMasterList.forEach(
        (mcqOptionMaster) => {
          mcqOptionMaster.selected = false;
          if (
            mcqOptionMaster.mcqOptionMasterId ==
            selectedMcqOptionMaster.mcqOptionMasterId
          ) {
            mcqOptionMaster.selected = true;
            this.examMCQMaster.mcqOptionMaster = mcqOptionMaster;
          }
        }
      );

      this.setSelectedMCQMaster(null);
    }
  }

  setSelectedMCQMaster(lookupCode: string) {
    let selectedType = new LookupData();
    let allType = new LookupData();
    let unansweredType = new LookupData();
    let flaggedType = new LookupData();
    this.errorMessage = "";

    if (lookupCode != null) {
      this.lookupCode = lookupCode;

      this.examMCQMaster.typeList.forEach((type) => {
        type.selected = false;

        if (type.lookupCode == "ALL") {
          allType = type;
        } else if (type.lookupCode == "UNANSWERED") {
          unansweredType = type;
        } else if (type.lookupCode == "FLAGGED") {
          flaggedType = type;
        }

        if (type.lookupCode == lookupCode) {
          selectedType = type;
          type.selected = true;
        }
      });

      if (this.examMCQMaster.isCompleted == true) {
        this.displayEndExam = false;

        if (this.timerRunning == true) {
          this.pauseTimer();
          this.timerText = "";
        }
      }

      if (this.examMCQMaster.errorMessage == "NO-ERROR") {
        this.questionError = false;
        this.questionNoError = true;

        this.showPreviousButton = true;
        if (this.examMCQMaster.srNo == 1) {
          this.showPreviousButton = false;
        }

        if (
          this.examMCQMaster.mcqMaster != null &&
          this.examMCQMaster.mcqMaster.mcqOptionMasterList.length > 0
        ) {
          this.examMCQMaster.mcqOptionMaster = new MCQOptionMaster();
          this.examMCQMaster.mcqMaster.mcqOptionMasterList.forEach(
            (mcqOptionMaster) => {
              mcqOptionMaster.selected = false;
              mcqOptionMaster.rightAnswer = false;
              mcqOptionMaster.wrongAnswer = false;
              mcqOptionMaster.isCompleted = false;
              mcqOptionMaster.isCompleted = this.examMCQMaster.isCompleted;

              if (
                mcqOptionMaster.mcqOptionMasterId ==
                this.examMCQMaster.mcqOptionMasterId
              ) {
                mcqOptionMaster.selected = true;
                this.examMCQMaster.mcqOptionMaster.mcqOptionMasterId =
                  mcqOptionMaster.mcqOptionMasterId;

                if (this.examMCQMaster.isCompleted == true) {
                  if (this.examMCQMaster.marks!! > 0) {
                    mcqOptionMaster.rightAnswer = true;
                  } else {
                    mcqOptionMaster.wrongAnswer = true;
                  }
                }
              }
            }
          );

          if (this.examMCQMaster.isCompleted == true) {
            this.examMCQMaster.mcqMaster.mcqOptionMasterList.forEach(
              (mcqOptionMaster) => {
                if (
                  mcqOptionMaster.mcqOptionMasterId ==
                  this.examMCQMaster.mcqMaster.mcqAnswerOptionMaster
                    .mcqOptionMasterId
                ) {
                  mcqOptionMaster.rightAnswer = true;
                }
              }
            );
          }
        }
      } else if (this.examMCQMaster.errorMessage == "NO-ALL-QUESTION") {
        this.questionNoError = false;
        this.questionError = true;
        this.errorMessage = allType.lookupKey + " questions were completed";
        this.showPreviousButton = true;
        if (this.examMCQMaster.srNo == 1) {
          this.showPreviousButton = false;
        }
      } else if (this.examMCQMaster.errorMessage == "NO-UNANSWERED-QUESTION") {
        this.questionNoError = false;
        this.questionError = true;
        this.errorMessage = "No " + unansweredType.lookupKey + " questions";
        this.showPreviousButton = true;
      } else if (this.examMCQMaster.errorMessage == "NO-FLAGGED-QUESTION") {
        this.questionNoError = false;
        this.questionError = true;
        this.showPreviousButton = true;

        if (unansweredType.lookupValue == "0") {
          this.errorMessage = "No " + flaggedType.lookupKey + " questions";
        } else {
          this.errorMessage =
            "No " +
            flaggedType.lookupKey +
            " questions, please click on " +
            unansweredType.lookupKey;
        }
      }

      if (
        this.examMCQMaster.srNo != null &&
        this.examMCQMaster.srNo.toString() == selectedType.lookupValue
      ) {
        this.nextButtonText = "Submit";
      } else {
        this.nextButtonText = "Next";
      }

      if (
        this.examMCQMaster.srNo == this.examMCQMaster.totalMCQ &&
        this.examMCQMaster.isCompleted == true
      ) {
        this.showCancelButton = true;
        this.showNextButton = false;
      } else {
        this.showCancelButton = false;
        this.showNextButton = true;
      }

      if (this.examMCQMaster.errorMessage != "NO-ERROR") {
        this.showNextButton = false;
      } else {
        if (
          this.examMCQMaster.srNo == this.examMCQMaster.totalMCQ &&
          this.examMCQMaster.isCompleted == true
        ) {
          this.showCancelButton = true;
          this.showNextButton = false;
        } else {
          this.showCancelButton = false;
          this.showNextButton = true;
        }
      }
    }

    let totalMCQs: number = +allType.lookupValue;

    if (totalMCQs != null) {
      let completedMCQs = totalMCQs - +unansweredType.lookupValue;
      this.completePercentage = (completedMCQs * 100) / totalMCQs;
    }

    if (this.examMCQMaster.isSkipped == false) {
      this.flagUnflagText = "Flag";
    } else {
      this.flagUnflagText = "Unflag";
    }
  }

  startTimer() {
    if (this.timerRunning == false) {
      this.timerRunning = true;

      this.actualSeconds = this.examMCQMaster.durationLeftInSeconds;
      this.timerMinute = Math.floor(this.actualSeconds / 60);
      this.timerSeconds = this.actualSeconds - this.timerMinute * 60;

      this.interval = setInterval(() => {
        this.timerText = "";

        if (this.timerSeconds > 0) {
          this.timerSeconds--;
        } else if (this.timerSeconds == 0) {
          this.timerMinute--;
          this.timerSeconds = 59;

          if (this.timerMinute < 0) {
            this.timerSeconds = 0;
            this.timerMinute = 0;

            this.pauseTimer();
          }
        } else {
          this.timerSeconds = 10;
        }

        if (this.timerMinute > 9) {
          this.timerText += this.timerMinute;
        } else {
          this.timerText += "0" + this.timerMinute;
        }

        this.timerText += ":";

        if (this.timerSeconds > 9) {
          this.timerText += this.timerSeconds;
        } else {
          this.timerText += "0" + this.timerSeconds;
        }

        this.timerText += " mins Left";
      }, 1000);
    }
  }

  previousButton() {
    let examMCQMasterTemp = new ExamMCQMaster();
    examMCQMasterTemp.examMCQMasterId = this.examMCQMaster.examMCQMasterId;
    examMCQMasterTemp.examMasterId = this.examMCQMaster.examMasterId;

    let typeTemp = new LookupData();
    typeTemp.lookupCode = this.lookupCode;
    examMCQMasterTemp.type = typeTemp;

    this.mainService.prevExamMCQMaster(examMCQMasterTemp).subscribe((data) => {
      this.examMCQMaster = data;

      this.setSelectedMCQMaster(this.lookupCode);
    });
  }

  nextButton() {
    let examMCQMasterTemp = new ExamMCQMaster();
    examMCQMasterTemp.examMCQMasterId = this.examMCQMaster.examMCQMasterId;
    examMCQMasterTemp.examMasterId = this.examMCQMaster.examMasterId;

    let mcqOptionMasterTemp = new MCQOptionMaster();

    this.examMCQMaster.mcqMaster.mcqOptionMasterList.forEach(
      (mcqOptionMaster) => {
        if (mcqOptionMaster.selected == true) {
          mcqOptionMasterTemp.mcqOptionMasterId =
            mcqOptionMaster.mcqOptionMasterId;
        }
      }
    );

    examMCQMasterTemp.mcqOptionMaster = mcqOptionMasterTemp;

    examMCQMasterTemp.durationLeftInSeconds =
      this.timerMinute * 60 + this.timerSeconds;

    let typeTemp = new LookupData();
    typeTemp.lookupCode = this.lookupCode;
    examMCQMasterTemp.type = typeTemp;

    this.errorMessage = "";
    if (
      this.examMCQMaster.isCompleted != true &&
      (examMCQMasterTemp.mcqOptionMaster == null ||
        examMCQMasterTemp.mcqOptionMaster.mcqOptionMasterId == null)
    ) {
      this.errorMessage = "Please Select Any 1 Option";
      return;
    }

    this.mainService
      .checkExamMCQMasterAnswer(examMCQMasterTemp)
      .subscribe((data) => {
        this.examMCQMaster = data;

        this.setSelectedMCQMaster(this.lookupCode);
      });
  }

  changeFlagExamMCQMaster() {
    let examMCQMasterTemp = new ExamMCQMaster();
    examMCQMasterTemp.examMCQMasterId = this.examMCQMaster.examMCQMasterId;
    examMCQMasterTemp.examMasterId = this.examMCQMaster.examMasterId;
    examMCQMasterTemp.isSkipped = !this.examMCQMaster.isSkipped;
    examMCQMasterTemp.durationLeftInSeconds =
      this.timerMinute * 60 + this.timerSeconds;

    let mcqOptionMasterTemp = new MCQOptionMaster();

    this.examMCQMaster.mcqMaster.mcqOptionMasterList.forEach(
      (mcqOptionMaster) => {
        if (mcqOptionMaster.selected == true) {
          mcqOptionMasterTemp.mcqOptionMasterId =
            mcqOptionMaster.mcqOptionMasterId;
        }
      }
    );

    examMCQMasterTemp.mcqOptionMaster = mcqOptionMasterTemp;

    this.mainService
      .changeFlagExamMCQMaster(examMCQMasterTemp)
      .subscribe((data) => {
        this.examMCQMaster = data;

        this.setSelectedMCQMaster(this.lookupCode);
      });
  }

  saveExamMasterResult() {
    let examMasterTemp = new ExamMaster();

    this.enrollCourseMasterTemp = new EnrollCourseMaster();
    this.enrollCourseMasterTemp.enrollCourseMasterId =
      this.authService.getEnrollCourseMasterSession().enrollCourseMasterId;
    examMasterTemp.enrollCourseMaster = this.enrollCourseMasterTemp;

    this.mainService.saveExamMasterResult(examMasterTemp).subscribe((data) => {
      this.examMaster = data;
      this.showEndExamDialog = false;
      this.actualSeconds = this.examMaster.timeTakenInSeconds;
      this.timerMinute = Math.floor(this.actualSeconds / 60);
      this.timerSeconds = this.actualSeconds - this.timerMinute * 60;

      this.pauseTimer();
      this.timerText = "";
      if (this.timerMinute > 9) {
        this.timerText += this.timerMinute;
      } else {
        this.timerText += "0" + this.timerMinute;
      }

      this.timerText += ":";

      if (this.timerSeconds > 9) {
        this.timerText += this.timerSeconds;
      } else {
        this.timerText += "0" + this.timerSeconds;
      }

      this.examfinish = true;
    });
  }

  endExam() {
    Swal.fire({
      customClass: {
        container: "logout-popup",
      },
      title: "Are you sure you want to End Exam?",

      showCancelButton: true,
      confirmButtonColor: "#faa41c",
      cancelButtonColor: "#fff",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.dismiss != null && result.dismiss != undefined) {
        Swal.close();
      } else {
        this.saveExamMasterResult();
      }
    });
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  backtoCourse() {
    this.router.navigateByUrl("/my-course");
  }

  startExam() {
    this.examfinish = false;
    this.saveExamMasterAndGetExamMCQ("ALL");
  }

  downloadFile(fileUrl: string) {
    if (fileUrl === null) {
      alert("No PDF to downlaod");
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);
  }

  sendCertificateOnEmail() {
    this.mainService.sendCertificateOnEmail(this.examMaster).subscribe(
      (data) => {
        Swal.fire({
          title: "Success",
          text: "Certificate Sent Successfully!",
          icon: "success",
          showCancelButton: true,
          showConfirmButton: true,
        });
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
          Swal.fire({
            title: "Success",
            text: "Certificate Sent Successfully!",
            icon: "success",
            showCancelButton: true,
            showConfirmButton: true,
          });
        }
      }
    );
  }
}
